/**
 * another comment
 */
import PropTypes from 'prop-types';

export default class CollageContainer extends React.Component {
  static propTypes = {
    displayCeremonyCollage: PropTypes.bool,
    toggleCollageEventHandler: PropTypes.func,
    ceremonyCollageData: PropTypes.array,
    receptionCollageData: PropTypes.array
  };

  static defaultProps = {
    displayCeremonyCollage: true,
    toggleCollageEventHandler: () => {},
    ceremonyCollageData: [],
    receptionCollageData: []
  };

  constructor() {
    super();
  }

  _retrieveActiveCollageData = (activeEvent) =>  (activeEvent === 'CEREMONY') ? [...this.props.ceremonyCollageData] : [...this.props.receptionCollageData];

  _createPinterestImgArray = (collageData) => {
    const imageArr = [];

    collageData.map((el) => {
      (el.imagePath.length > 0) ? imageArr.push({ url: `//cdn.sandals.com/sandals${el.imagePath}` }) : null;
    });

    return imageArr;
  }

  _renderTile = (tileData, isLarge = false, hiddenXxl = false, xxlClassName = '') => {
    const isSelectedSubCategory = tileData.imagePath.length > 0;
    const isLargeTile = (isLarge) ? `xs-8 xl-12 ${xxlClassName}` : `xs-12 xl-6 ${xxlClassName} ${hiddenXxl ? 'hidden-xxl-down' : ''}`;
    const urlParameters = `?isCeremony=${tileData.event === 'CEREMONY'}&category=${encodeURIComponent(tileData.subcategoryId)}`;

    return (
      <div className={`collage-square-tile txt-center ${isLargeTile} ${isSelectedSubCategory}`}>
        <a href={`/weddings/ideas/wishlist-catalog/${urlParameters}`} className="display-block font-bold">
          { !isSelectedSubCategory && `${tileData.subcategoryName} ` }
          { !isSelectedSubCategory && <span className="display-block add-item-btn-copy">ADD ITEM</span>}
          { isSelectedSubCategory && <img src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" data-src={`//cdn.sandals.com/sandals${tileData.imagePath}`} className="lazyload img-responsive use-attributes" alt=""/> }
        </a>
      </div>
    );
  }

  _renderEventCollage = (activeEvent) => {
    const activeCollageData = this._retrieveActiveCollageData(activeEvent);
    // const collageDataHasImgs = this._createPinterestImgArray(activeCollageData).length > 0;
    const isActiveCollage = (activeEvent === 'RECEPTION' && !this.props.displayCeremonyCollage) ? 'active' : '';
    const hideReceptionCollage = (activeEvent === 'CEREMONY' && !this.props.displayCeremonyCollage) ? 'top-secret' : '';

    return (
      <div className={`collage-tiles-innerwrapper row center-xs ${(activeEvent === 'RECEPTION') ? 'pa' : ''} ${isActiveCollage} ${hideReceptionCollage}`}>
        <div className="xs-12 xl-4 no-grid-gutter left">
          <div className="row">
            <div className="xl-12 hidden-xxl-down no-pad-left-xxl">
              <div className="row">
                {
                  this._renderTile(activeCollageData[8])
                }
                {
                  this._renderTile(activeCollageData[9])
                }
              </div>
            </div>
            {
              this._renderTile(activeCollageData[0], true)
            }
            <div className="xs-4 xl-12 no-pad-left-xxl">
              <div className="row">
                {
                  this._renderTile(activeCollageData[1])
                }
                {
                  this._renderTile(activeCollageData[2])
                }
              </div>
            </div>
          </div>
        </div>
        <div className="xs-12 xl-4 no-grid-gutter center">
          <div className="row">
            <div className="xs-12 collage-ttl-wrapper txt-center pr">
              {
                <span className="collage-ttl">{`YOUR ${activeEvent}`}</span>
              }
              <span className="collage-subttl"> SELECTED ITEMS</span>
            </div>
          </div>
          <div className="row hidden-xlarge-down">
            {
              this._renderTile(activeCollageData[7], true)
            }
          </div>
        </div>
        <div className="xs-12 xl-4 no-grid-gutter right">
          <div className="row">
            <div className="xs-4 xl-12">
              <div className="row">
                {
                  this._renderTile(activeCollageData[3], false, false, 'xxl-4')
                }
                {
                  this._renderTile(activeCollageData[4], false, false, 'xxl-4')
                }
                {
                  this._renderTile(activeCollageData[6], false, true, 'xxl-4')
                }
              </div>
            </div>
            {
              this._renderTile(activeCollageData[5], true)
            }
          </div>
        </div>
        <div className={`xs-12 ${(activeEvent === 'CEREMONY') ? 'txt-right' : 'txt-left'}`}>
          <button className="change-collage-event-btn font-bold" onClick={ this.props.toggleCollageEventHandler }>
            {(activeEvent === 'RECEPTION') && <i className="ic ic-button-arrow-prev ib"/>}
            {
              `VIEW ${(activeEvent === 'CEREMONY') ? 'RECEPTION' : 'CEREMONY' }`
            }
            {(activeEvent === 'CEREMONY') && <i className="icon-arrow-next ib"/>}
          </button>
        </div>
      </div>
    );
  }
  render() {

    return (
      <section className="collage-tiles-container pr">
        {
          this._renderEventCollage('CEREMONY')
        }
        {
          this._renderEventCollage('RECEPTION')
        }
      </section>
    );
  }
}
